import { isEmpty } from 'lodash';

export const errorMessage = __('This field is required');

type FormValue = string | number | boolean | object | null | undefined;
type ValidationResult = string | undefined;

export const validateRequired = (value: FormValue): ValidationResult => {
  let isValid = false;

  if (typeof value === 'number') {
    isValid = Number.isFinite(value);
  } else if (typeof value === 'boolean') {
    isValid = true;
  } else if (typeof value === 'string') {
    isValid = value.trim() !== '';
  } else if (value instanceof Date) {
    isValid = !Number.isNaN(value.getTime());
  } else {
    isValid = !isEmpty(value);
  }

  return isValid ? undefined : errorMessage;
};

export const validateRequiredForArray = (
  value: FormValue,
): ValidationResult => {
  if (!Array.isArray(value)) {
    return errorMessage;
  }

  const hasValidValues = value.some(
    (item) => validateRequired(item) === undefined,
  );

  return hasValidValues ? undefined : errorMessage;
};

export const validateRequiredForCheckbox = (
  value: FormValue,
): ValidationResult => {
  let error: ValidationResult;

  if (value === 'true') {
    return error;
  }

  error = errorMessage;

  return error;
};
